import { GridItem, Box, Stack, Text } from '@chakra-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import colors from '../../../../../styles/colors';

interface FormElementItemProps {
  label: string;
  icon: React.ComponentType<{ size?: string; color?: string }>;
  type: string;
  onPointerDown: (e: React.PointerEvent, type: string) => void;
  onPointerMove: (e: React.PointerEvent) => void;
  onPointerUp: (e: React.PointerEvent) => void;
  onPointerCancel: (e: React.PointerEvent) => void;
}

export const FormElementItem = React.memo<FormElementItemProps>(function FormElementItem({
  label,
  icon: IconComponent,
  type,
  onPointerDown,
  onPointerMove,
  onPointerUp,
  onPointerCancel,
}) {
  const { t } = useTranslation('questionnaireTemplate');
  return (
    <GridItem colSpan={1} display="flex" justifyContent="center" minHeight="95px">
      <Box
        data-testid={`form-element-${type}`}
        borderRadius="4px"
        padding={2}
        border="1px solid"
        borderColor="transparent"
        onPointerDown={(e) => onPointerDown(e, type)}
        onPointerMove={onPointerMove}
        onPointerUp={onPointerUp}
        onPointerCancel={onPointerCancel}
        userSelect="none"
        cursor="grab"
        bg="rgba(243, 246, 249, 1)"
        _hover={{
          bg: 'rgba(233, 237, 241, 1)',
          borderColor: 'rgba(199, 203, 207, 1)',
        }}
        flex={1}
        _active={{ cursor: 'grabbing' }}
        display="flex"
        alignItems="center"
        justifyContent="center"
      >
        <Stack align="center" justify="center">
          <IconComponent size="24px" color={colors.gray[700]} />
          <Text textAlign="center" fontWeight={700} fontSize="sm" lineHeight="21px">
            {t(`formBuilder.schema.${label}`)}
          </Text>
        </Stack>
      </Box>
    </GridItem>
  );
});
